import React, { createContext, useContext, useState } from 'react';

// Create a context for the session
const SessionContext = createContext();

// Custom hook to use the SessionContext
export const useSession = () => {
    return useContext(SessionContext);
};

// Provider component
export const SessionProvider = ({ children }) => {
    const [session, setSession] = useState(() => {
        const savedSession = sessionStorage.getItem('cpdl_session');
        return savedSession ? JSON.parse(savedSession) : {};
    });

    const setItem = (key, value) => {
        const newSession = { ...session, [key]: value };
        setSession(newSession);
        sessionStorage.setItem('cpdl_session', JSON.stringify(newSession));
    };

    const getItem = (key) => {
        return session[key];
    };

    const removeItem = (key) => {
        const { [key]: _, ...newSession } = session;
        setSession(newSession);
        sessionStorage.setItem('cpdl_session', JSON.stringify(newSession));
    };

    const saveSession = (oData) => {
        const newSession = { ...session, ...oData };
        setSession(newSession);
        sessionStorage.setItem('cpdl_session', JSON.stringify(newSession));
    }

    const clearSession = () => {
        setSession({});
        sessionStorage.removeItem('cpdl_session');
    };

    const value = {
        session,
        setItem,
        getItem,
        removeItem,
        saveSession,
        clearSession
    }

    return (
        <SessionContext.Provider value={value}>
            {children}
        </SessionContext.Provider>
    );
};